/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ScoringSubmission } from './scoringSubmission';

export type SubmitModuleFeedbackScoring = ScoringSubmission | null;
